import type { IImportTemplateService } from './IImportTemplateService';
import type { ImportTemplate } from '../dto/ImportTemplate.dto';
import type { CreateImportTemplateRequest } from '../dto/CreateImportTemplateRequest';
import type { UpdateImportTemplateRequest } from '../dto/UpdateImportTemplateRequest';

import { JsonRequestBody } from '../http/JsonRequestBody';
import { PagedResponse } from '../dto/PagedResponse';
import { ListParams, QueryBuilder } from '../http';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { fetchWithAuth } from '../../../utils/fetch/FetchWithAuth';

const BASE = '/api/warehouse/import-template';

export class ImportTemplateService implements IImportTemplateService {
    async list(params?: Partial<ListParams>): Promise<PagedResponse<ImportTemplate>> {
        return fetchWithAuth(`${BASE}${QueryBuilder.from(params).build()}`, {
            method: 'GET',
        });
    }

    async get(externalId: string): Promise<ImportTemplate> {
        return fetchWithAuth(`${BASE}/${externalId}`, {
            method: 'GET',
        });
    }

    async create(
        payload: CreateImportTemplateRequest,
    ): Promise<ImportTemplate> {
        return fetchWithAuth(BASE, {
            method: 'POST',
            ...JsonRequestBody.from(payload),
        });
    }

    async update(
        externalId: string,
        payload: UpdateImportTemplateRequest,
    ): Promise<ImportTemplate> {
        return fetchWithAuth(`${BASE}/${externalId}`, {
            method: 'PATCH',
            ...JsonRequestBody.from(payload),
        });
    }

    async delete(externalId: string): Promise<void> {
        return fetchWithAuth(`${BASE}/${externalId}`, {
            method: 'DELETE',
        });
    }
}